// import React from "react";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";

// const MemoizedMarkdown = React.memo(({ content }) => {
//   // FIX: Removed the global replace of <br> with \n because it breaks markdown table syntax.
//   // The <br> tags will be handled inside the 'td' component below.
//   const processedContent = content || "";

//   return (
//     <ReactMarkdown
//       remarkPlugins={[remarkGfm]}
//       components={{
//         // Tighter paragraph spacing
//         p: ({ children }) => (
//           <p style={{ margin: "0 0 6px 0", lineHeight: "1.6" }}>{children}</p>
//         ),

//         // List spacing
//         ul: ({ children }) => (
//           <ul
//             style={{
//               margin: "6px 0",
//               paddingLeft: "20px",
//               listStyleType: "disc",
//             }}
//           >
//             {children}
//           </ul>
//         ),
//         ol: ({ children }) => (
//           <ol
//             style={{
//               margin: "6px 0",
//               paddingLeft: "20px",
//               listStyleType: "decimal",
//             }}
//           >
//             {children}
//           </ol>
//         ),
//         li: ({ children }) => (
//           <li style={{ margin: "2px 0", lineHeight: "1.5" }}>{children}</li>
//         ),

//         // Headers with proper spacing
//         h1: ({ children }) => (
//           <h1
//             style={{
//               fontSize: "18px",
//               fontWeight: "700",
//               margin: "12px 0 6px",
//               lineHeight: "1.3",
//             }}
//           >
//             {children}
//           </h1>
//         ),
//         h2: ({ children }) => (
//           <h2
//             style={{
//               fontSize: "16px",
//               fontWeight: "700",
//               margin: "10px 0 4px",
//               lineHeight: "1.3",
//             }}
//           >
//             {children}
//           </h2>
//         ),
//         h3: ({ children }) => (
//           <h3
//             style={{
//               fontSize: "15px",
//               fontWeight: "600",
//               margin: "8px 0 4px",
//               lineHeight: "1.3",
//             }}
//           >
//             {children}
//           </h3>
//         ),

//         // Bold and Italic
//         strong: ({ children }) => (
//           <strong style={{ fontWeight: "600" }}>{children}</strong>
//         ),
//         em: ({ children }) => (
//           <em style={{ fontStyle: "italic" }}>{children}</em>
//         ),

//         // Code blocks
//         code: ({ node, inline, className, children, ...props }) => {
//           return inline ? (
//             <code
//               style={{
//                 backgroundColor: "#f4f4f5",
//                 padding: "2px 6px",
//                 borderRadius: "4px",
//                 fontSize: "13px",
//               }}
//               {...props}
//             >
//               {children}
//             </code>
//           ) : (
//             <code
//               style={{
//                 display: "block",
//                 backgroundColor: "#f4f4f5",
//                 padding: "12px",
//                 borderRadius: "6px",
//                 margin: "8px 0",
//                 fontSize: "13px",
//                 overflowX: "auto",
//               }}
//               {...props}
//             >
//               {children}
//             </code>
//           );
//         },

//         // Blockquotes
//         blockquote: ({ children }) => (
//           <blockquote
//             style={{
//               margin: "8px 0",
//               paddingLeft: "16px",
//               borderLeft: "3px solid #C95EBE",
//               color: "#52525b",
//               fontStyle: "italic",
//             }}
//           >
//             {children}
//           </blockquote>
//         ),

//         // Keep your table styling
//         table: ({ children }) => (
//           <div style={{ overflowX: "auto", margin: "10px 0" }}>
//             <table
//               style={{
//                 borderCollapse: "collapse",
//                 width: "100%",
//                 border: "1px solid rgb(201, 94, 190)",
//               }}
//             >
//               {children}
//             </table>
//           </div>
//         ),
//         thead: ({ children }) => (
//           <thead style={{ backgroundColor: "rgb(250, 235, 247)" }}>
//             {children}
//           </thead>
//         ),
//         tbody: ({ children }) => <tbody>{children}</tbody>,
//         tr: ({ children }) => <tr>{children}</tr>,
//         th: ({ children }) => (
//           <th
//             style={{
//               padding: "8px",
//               textAlign: "left",
//               border: "1px solid rgb(201, 94, 190)",
//               color: "rgb(201, 94, 190)",
//               fontSize: "14px",
//               fontWeight: "600",
//             }}
//           >
//             {children}
//           </th>
//         ),
//         // FIX: Enhanced td to handle <br> tags internally for multiline cells
//         td: ({ children }) => {
//           const processChildren = (nodes) => {
//             return React.Children.map(nodes, (node) => {
//               if (typeof node === "string") {
//                 const parts = node.split(/<br\s*\/?>/gi);
//                 if (parts.length === 1) return node;
//                 return parts.map((part, index) => (
//                   <React.Fragment key={index}>
//                     {index > 0 && <br />}
//                     {part}
//                   </React.Fragment>
//                 ));
//               }
//               if (Array.isArray(node)) {
//                 return processChildren(node);
//               }
//               return node;
//             });
//           };

//           return (
//             <td
//               style={{
//                 padding: "8px",
//                 border: "1px solid rgba(201, 94, 190, 0.3)",
//                 fontSize: "13px",
//                 whiteSpace: "pre-wrap",
//                 verticalAlign: "top",
//               }}
//             >
//               {processChildren(children)}
//             </td>
//           );
//         },
//       }}
//     >
//       {processedContent}
//     </ReactMarkdown>
//   );
// });

// export default MemoizedMarkdown;
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw"; // NEW: Add this import

const MemoizedMarkdown = React.memo(({ content }) => {
  let processedContent = content || "";

  // PRE-PROCESSING STEP: Fix markdown inside HTML spans
  // This takes <span style="...">***Text***</span> and turns it into ***<span style="...">Text</span>***
  // It handles ***, **, and * so bolding and italics work even when colored!
  processedContent = processedContent.replace(
    /(<span[^>]*>)\s*(\*{1,3})(.*?)(\*{1,3})\s*(<\/span>)/g,
    (match, openSpan, startStars, innerText, endStars, closeSpan) => {
      return `${startStars}${openSpan}${innerText}${closeSpan}${endStars}`;
    }
  );

  return (
    <ReactMarkdown
    
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]} // NEW: This allows spans and HTML colors to render natively
      components={{
        // Tighter paragraph spacing
        p: ({ children }) => (
          <p style={{ margin: "0 0 6px 0", lineHeight: "1.6" }}>{children}</p>
        ),

        // List spacing
        ul: ({ children }) => (
          <ul
            style={{
              margin: "6px 0",
              paddingLeft: "20px",
              listStyleType: "disc",
            }}
          >
            {children}
          </ul>
        ),
        ol: ({ children }) => (
          <ol
            style={{
              margin: "6px 0",
              paddingLeft: "20px",
              listStyleType: "decimal",
            }}
          >
            {children}
          </ol>
        ),
        li: ({ children }) => (
          <li style={{ margin: "2px 0", lineHeight: "1.5" }}>{children}</li>
        ),

        // Headers with proper spacing
        h1: ({ children }) => (
          <h1
            style={{
              fontSize: "18px",
              fontWeight: "700",
              margin: "12px 0 6px",
              lineHeight: "1.3",
            }}
          >
            {children}
          </h1>
        ),
        h2: ({ children }) => (
          <h2
            style={{
              fontSize: "16px",
              fontWeight: "700",
              margin: "10px 0 4px",
              lineHeight: "1.3",
            }}
          >
            {children}
          </h2>
        ),
        h3: ({ children }) => (
          <h3
            style={{
              fontSize: "15px",
              fontWeight: "600",
              margin: "8px 0 4px",
              lineHeight: "1.3",
            }}
          >
            {children}
          </h3>
        ),

        // Bold and Italic
        strong: ({ children }) => (
          <strong style={{ fontWeight: "600" }}>{children}</strong>
        ),
        em: ({ children }) => (
          <em style={{ fontStyle: "italic" }}>{children}</em>
        ),

        // Links: two distinct kinds share this override.
        // 1) Inline citation markers (`#source_viewer`) injected as raw HTML
        //    by the streaming handlers, carrying data-filename/data-fileurl/
        //    data-page/data-pagecontent read by handleMarkdownClick. These
        //    must keep their own attributes/style (a `...rest` spread) and
        //    must NOT open in a new tab — the click handler intercepts them
        //    to open the in-app source viewer instead.
        // 2) Regular markdown links (e.g. web-search results) — open in a
        //    new tab so the chat stays put; noopener/noreferrer since these
        //    are external URLs.
        a: ({ href, children, ...rest }) =>
          href === "#source_viewer" ? (
            <a href={href} {...rest}>
              {children}
            </a>
          ) : (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#C95EBE",
                textDecoration: "underline",
                fontWeight: 500,
                wordBreak: "break-word",
              }}
              {...rest}
            >
              {children}
            </a>
          ),

        // Code blocks
        code: ({ node, inline, className, children, ...props }) => {
          return inline ? (
            <code
              style={{
                backgroundColor: "#f4f4f5",
                padding: "2px 6px",
                borderRadius: "4px",
                fontSize: "13px",
              }}
              {...props}
            >
              {children}
            </code>
          ) : (
            <code
              style={{
                display: "block",
                backgroundColor: "#f4f4f5",
                padding: "12px",
                borderRadius: "6px",
                margin: "8px 0",
                fontSize: "13px",
                overflowX: "auto",
              }}
              {...props}
            >
              {children}
            </code>
          );
        },

        // Blockquotes
        blockquote: ({ children }) => (
          <blockquote
            style={{
              margin: "8px 0",
              paddingLeft: "16px",
              borderLeft: "3px solid #C95EBE",
              color: "#52525b",
              fontStyle: "italic",
            }}
          >
            {children}
          </blockquote>
        ),

        // Keep your table styling
        table: ({ children }) => (
          <div style={{ overflowX: "auto", margin: "10px 0" }}>
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
                border: "1px solid rgb(201, 94, 190)",
              }}
            >
              {children}
            </table>
          </div>
        ),
        thead: ({ children }) => (
          <thead style={{ backgroundColor: "rgb(250, 235, 247)" }}>
            {children}
          </thead>
        ),
        tbody: ({ children }) => <tbody>{children}</tbody>,
        tr: ({ children }) => <tr>{children}</tr>,
        th: ({ children }) => (
          <th
            style={{
              padding: "8px",
              textAlign: "left",
              border: "1px solid rgb(201, 94, 190)",
              color: "rgb(201, 94, 190)",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            {children}
          </th>
        ),
        td: ({ children }) => {
          const processChildren = (nodes) => {
            return React.Children.map(nodes, (node) => {
              if (typeof node === "string") {
                const parts = node.split(/<br\s*\/?>/gi);
                if (parts.length === 1) return node;
                return parts.map((part, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <br />}
                    {part}
                  </React.Fragment>
                ));
              }
              if (Array.isArray(node)) {
                return processChildren(node);
              }
              return node;
            });
          };

          return (
            <td
              style={{
                padding: "8px",
                border: "1px solid rgba(201, 94, 190, 0.3)",
                fontSize: "13px",
                whiteSpace: "pre-wrap",
                verticalAlign: "top",
              }}
            >
              {processChildren(children)}
            </td>
          );
        },
      }}
    >
      {processedContent}
    </ReactMarkdown>
  );
});

export default MemoizedMarkdown;
